'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reduxSimple = require('redux-simple');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Common = require('components/Common');

var _routing = require('actions/routing');

var _firebase = require('utils/firebase');

var _firebase2 = _interopRequireDefault(_firebase);

var _editorHelpers = require('./editorHelpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* injects from baggage-loader */
var styles = require('./Viewer.pcss');

var getState = function getState(state) {
  return {
    node: state.nodes.editorNode,
    project: state.projects.project,
    shownUser: state.user.shownUser
  };
};

var NodePage = (_dec = (0, _reduxSimple.connect)(getState, { viewProject: _routing.viewProject }), _dec(_class = (_temp = _class2 = function (_Component) {
  _inherits(NodePage, _Component);

  function NodePage() {
    _classCallCheck(this, NodePage);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(NodePage).call(this));

    _this.state = {
      ready: false,
      content: null
    };
    return _this;
  }

  _createClass(NodePage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.init(this.props);
    }
  }, {
    key: 'setContent',
    value: function setContent(data) {
      this.setState({ ready: true, content: data });
    }
  }, {
    key: 'init',
    value: function init(props) {
      var _this2 = this;

      if (!props.node) return;
      var refLink = props.node.refLink;

      var firepadRefPath = refLink + '/firepad';

      this.firepadRef = (0, _firebase2.default)(firepadRefPath);

      this.firepad = new window.Firepad.Headless(this.firepadRef);
      this.firepad.entityManager_.register('a', {
        render: _editorHelpers.makeLinkFromFirebase,
        export: _editorHelpers.makeLinkFromFirebase,
        fromElement: _editorHelpers.makeFirebaseFromLink
      });

      this.firepad.getHtml(function (data) {
        _this2.setContent(data);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.firepad) this.firepad.dispose();
    }
  }, {
    key: 'getEmptyNodeContent',
    value: function getEmptyNodeContent() {
      var _this3 = this;

      var _props = this.props;
      var node = _props.node;
      var project = _props.project;
      var shownUser = _props.shownUser;


      var nodeCaption = node.caption;
      var projectTitle = project.name;
      var goToProjects = function goToProjects() {
        _this3.props.viewProject(shownUser.id, project.id);
      };

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(styles.viewer) },
        _react2.default.createElement(
          'div',
          null,
          nodeCaption
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'p',
          { className: (0, _classnames2.default)(styles.emptyContentCaption) },
          'This is just a piece of "',
          projectTitle,
          '" project and',
          _react2.default.createElement('br', null),
          'has no content yet.'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          _Common.Button,
          { onClick: goToProjects },
          'Go to the project'
        )
      );
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var _this4 = this;

      if (props.node && props.node.id !== _lodash2.default.get(this.props.node, 'id')) {
        this.setState({ ready: false });
        setTimeout(function () {
          return _this4.init(props);
        }, 100);
      } else if (props.node && props.node.timestamp !== _lodash2.default.get(this.props.node, 'timestamp')) {
        this.firepad.getHtml(function (data) {
          _this4.setContent(data);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.state.ready) {
        return _react2.default.createElement(
          'div',
          { className: styles.firepad },
          this.props.spinner
        );
      }

      return _react2.default.createElement(
        'div',
        { className: styles.firepad },
        this.state.content !== '' ? _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.viewer), dangerouslySetInnerHTML: { __html: this.state.content } }) : this.getEmptyNodeContent()
      );
    }
  }]);

  return NodePage;
}(_react.Component), _class2.propTypes = {
  node: _react.PropTypes.object,
  spinner: _react.PropTypes.any.isRequired
}, _temp)) || _class);
exports.default = NodePage;


//////////////////
// WEBPACK FOOTER
// ./app/components/Nodes/Viewer.js
// module id = 565
// module chunks = 1